module.exports = __webpack_public_path__ + "img/9788959759392.faa19b6a.jpg";